import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import ReactSelect from "../../../Components/PortalSelect";
import { RevertBackSchema } from "../../../ValidationSchema";
import Modal from "../../../Components/Modal";

const GraphicDesingerMokup = ({ show, userId, orderId, onClose }) => {
  const Navigate = useNavigate();
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const [data, setData] = useState([]);
  const [totalpage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [activePreviewIndex, setActivePreviewIndex] = useState(0);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_URL}/admin/graphic_designer/order/products/design`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((res) => {
        const filteredData = res?.data.data?.filter(
          (item) => item.order_id === parseInt(orderId)
        );
        setData(filteredData);
      })
      .catch((err) => {
        setData([]);
        setActivePreviewIndex(0); // reset when new data arrives
        if (err.response?.data?.message === "Unauthorized!") {
          Navigate("/");
        }
      });
    // eslint-disable-next-line
  }, [page, search, orderId, userId]);

  const handleThumbnailClick = (index) => {
    setActivePreviewIndex(index);
  };

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      border: "1px solid #bfc9d4",
      boxShadow: "#000 !important",
      borderRadius: "6px",
      padding: "4px",
      "&:hover": {
        border: "1px solid #bfc9d4",
      },
    }),
    multiValue: (styles) => {
      return {
        ...styles,
        backgroundColor: "#606060",
      };
    },
    multiValueLabel: (styles) => ({
      ...styles,
      color: "#fff",
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "#000",
      "& > svg": {
        backgroundColor: "#fff",
        borderRadius: "10px",
        marginLeft: "2px",
        marginRight: "2px",
      },
      ":hover": {
        backgroundColor: data.color,
        color: data.color,
      },
    }),
    option: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: "white",
        color: "#000",
        ":hover": {
          backgroundColor: "#f5f5f5",
        },
      };
    },
  };

  const handleRemoveDesign = async (indexToRemove, graphic_design_id) => {
    const fileToDelete = data[indexToRemove]?.design_url;

    try {
      // const graphic_design_id = AddDesignStudios.values.order_id;

      if (!graphic_design_id) {
        toast.error("graphic_design_id is required before removing media.");
        return;
      }

      const config = {
        headers: {
          "j-authorization": localStorage.getItem("Token"),
        },
      };

      const res = await axios.delete(
        `${process.env.REACT_APP_URL}/admin/graphic_designer/design/${graphic_design_id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      );

      if (res.status === 200) {
        toast.success(res.data.message);

        const updatedData = data.filter((_, i) => i !== indexToRemove);

        // Update main preview index
        if (indexToRemove === activePreviewIndex) {
          setActivePreviewIndex(0);
        } else if (indexToRemove < activePreviewIndex) {
          setActivePreviewIndex((prev) => prev - 1);
        }

        setData(updatedData);
        window?.location?.reload();
        // fetchDesignStudioDetails(); // Refresh from backend
      } else {
        toast.error("Failed to remove media.");
      }
    } catch (err) {
      console.error("Remove media error:", err);
      toast.error(err?.response?.data?.message || "Something went wrong");
    }
  };

  React.useEffect(() => {}, [orderId]);

  const active = data?.[activePreviewIndex];

  return (
    <Modal
      open={!!show}
      onClose={onClose}
      title="Graphic Designer Mockup"
      subtitle={
        data?.length > 0
          ? `${data.length} design${data.length === 1 ? "" : "s"} uploaded${
              orderId ? ` · Order #${orderId}` : ""
            }`
          : "No designs uploaded yet"
      }
      size="lg"
    >
      {data?.length > 0 ? (
        <>
          <div className="al-stage">
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}${active?.design_url}`}
              alt="Selected design"
            />
          </div>

          <div className="al-picker">
            {data.map((item, index) => (
              <div key={index} style={{ position: "relative" }}>
                <button
                  type="button"
                  className={`al-picker__i ${
                    index === activePreviewIndex ? "is-active" : ""
                  }`}
                  title={`Design ${index + 1}`}
                  onClick={() => handleThumbnailClick(index)}
                >
                  <img
                    src={`${process.env.REACT_APP_IMAGE_URL}${item.design_url}`}
                    alt={`Design ${index + 1}`}
                  />
                </button>
                <button
                  type="button"
                  className="al-picker__x"
                  title="Remove this design"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveDesign(index, item.graphic_design_id);
                  }}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="al-empty" style={{ padding: "32px 20px" }}>
          <div className="al-empty__icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><polyline points="21 15 16 10 5 21" /></svg>
          </div>
          <p className="al-empty__title">No mockups yet</p>
          <p className="al-empty__text">
            Designs uploaded by the graphic designer will appear here.
          </p>
        </div>
      )}
    </Modal>
  );
};

export default GraphicDesingerMokup;
